export default __webpack_public_path__ + "static/media/913.bc1dcbe0.png";